import { getClassroomApiUrl } from "@/js/utils/getBackendUrl";
import * as clsApi from "@/js/api/classroomApi";

export type PauseGivenStudentsRequest = {
	studentIds: string[];
};

export async function pauseGivenStudents(
	teacherId: string,
	classroomId: string,
	studentIds: string[],
	authHeaders = clsApi.authHeaders(),
	host = getClassroomApiUrl(window.location.hostname)
): Promise<void> {
	const payload: PauseGivenStudentsRequest = {
		studentIds: studentIds,
	};

	const response = await fetch(`${host}/v2/teachers/${teacherId}/classrooms/${classroomId}/pause`, {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
			user: teacherId,
			Authorization: authHeaders.Authorization,
			Device: authHeaders.Device,
		},
		body: JSON.stringify(payload),
	});

	if (!response.ok) {
		throw new Error(`Failed to pause students: ${response.status}`);
	}
}

export async function unpauseAllStudents(
	teacherId: string,
	classroomId: string,
	authHeaders = clsApi.authHeaders(),
	host = getClassroomApiUrl(window.location.hostname)
): Promise<void> {
	const response = await fetch(`${host}/v2/teachers/${teacherId}/classrooms/${classroomId}/end-pause`, {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
			user: teacherId,
			Authorization: authHeaders.Authorization,
			Device: authHeaders.Device,
		},
	});

	if (!response.ok) {
		throw new Error(`Failed to unpause students: ${response.status}`);
	}
}

export async function togglePauseForStudent(
	teacherId: string,
	classroomId: string,
	studentId: string,
	authHeaders = clsApi.authHeaders(),
	host = getClassroomApiUrl(window.location.hostname)
): Promise<void> {
	const response = await fetch(`${host}/v2/teachers/${teacherId}/classrooms/${classroomId}/students/${studentId}/pause`, {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
			user: teacherId,
			Authorization: authHeaders.Authorization,
			Device: authHeaders.Device,
		},
	});

	if (!response.ok) {
		throw new Error(`Failed to toggle pause for student: ${response.status}`);
	}
}
